(function() {
  var MOBILE_MAX = 749;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function setupCard(inner) {
    if (inner.dataset.jbSwipeSetup) return;
    if (!isMobile()) return;

    var first = inner.querySelector('.product-first-image');
    var second = inner.querySelector('.product-secondary-image');
    if (!first || !second) return;

    inner.dataset.jbSwipeSetup = '1';
    inner.classList.add('jb-swipe-media');

    // Build dots
    var dots = document.createElement('div');
    dots.className = 'jb-swipe-dots';
    dots.innerHTML = '<span class="jb-swipe-dot active"></span><span class="jb-swipe-dot"></span>';
    inner.appendChild(dots);
    var dotEls = dots.querySelectorAll('.jb-swipe-dot');

    var current = 0;
    var startX = 0, startY = 0, deltaX = 0, dragging = false, moved = false;

    function goTo(index) {
      current = index;
      inner.style.setProperty('--jb-swipe-offset', (-index * 100) + '%');
      dotEls.forEach(function(d, i) { d.classList.toggle('active', i === index); });
    }

    inner.addEventListener('touchstart', function(e) {
      if (!isMobile()) return;
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      dragging = true;
      moved = false;
      inner.classList.add('jb-swipe-dragging');
    }, { passive: true });

    inner.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      var t = e.touches[0];
      deltaX = t.clientX - startX;
      var deltaY = t.clientY - startY;
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        moved = true;
        var base = -current * 100;
        var pct = (deltaX / inner.offsetWidth) * 100;
        inner.style.setProperty('--jb-swipe-offset', (base + pct) + '%');
      }
    }, { passive: true });

    inner.addEventListener('touchend', function(e) {
      inner.classList.remove('jb-swipe-dragging');
      dragging = false;
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0 && current === 0) goTo(1);
        else if (deltaX > 0 && current === 1) goTo(0);
        else goTo(current);
      } else {
        goTo(current);
      }
      if (moved) {
        // Prevent the card link from navigating on a real swipe
        var link = inner.closest('.product-link') || inner.querySelector('.product-link');
        var suppress = function(ev) { ev.preventDefault(); ev.stopPropagation(); };
        if (link) {
          link.addEventListener('click', suppress, { once: true, capture: true });
        }
      }
      deltaX = 0;
    });
  }

  function processAll() {
    document.querySelectorAll('.card-product__media-inner.card-product__media-secondary-image').forEach(setupCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }
  window.addEventListener('resize', processAll);
  new MutationObserver(processAll).observe(document.body, { childList: true, subtree: true });
})();
